(function () {
  'use strict';

  var grid = document.querySelector('#CollectionAjaxContent .grid--uniform');
  var pagination = document.querySelector('#CollectionAjaxContent .pagination');

  if (!grid || !pagination) return;

  // Lightweight products-only section — skips filter facet computation
  var AJAX_SECTION_ID = 'collection-products-ajax';

  var loading = false;
  var sentinelVisible = false;

  function getNextUrl() {
    var nextLink = pagination.querySelector('.next a');
    return nextLink ? nextLink.getAttribute('href') : null;
  }

  function buildSectionUrl(pageUrl) {
    var sep = pageUrl.includes('?') ? '&' : '?';
    return pageUrl + sep + 'sections=' + AJAX_SECTION_ID;
  }

  function updatePagination(doc) {
    var newPagination = doc.querySelector('.pagination');
    if (newPagination) {
      pagination.innerHTML = newPagination.innerHTML;
    } else {
      var nextEl = pagination.querySelector('.next');
      if (nextEl) nextEl.remove();
    }
  }

  function loadNextPage() {
    var nextUrl = getNextUrl();
    if (!nextUrl || loading) return;

    loading = true;

    fetch(buildSectionUrl(nextUrl))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[AJAX_SECTION_ID];
        if (!html) { loading = false; return; }

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = doc.querySelectorAll('#CollectionAjaxProducts .grid--uniform > *');
        newItems.forEach(function (item) {
          grid.appendChild(item.cloneNode(true));
        });

        updatePagination(doc);
        loading = false;

        if (window.AOS) { AOS.refreshHard(); }

        // If sentinel still visible (fast scroll), chain next load immediately
        if (sentinelVisible && getNextUrl()) {
          loadNextPage();
        }
      })
      .catch(function () {
        loading = false;
      });
  }

  var sentinel = document.createElement('div');
  sentinel.style.height = '1px';
  pagination.insertAdjacentElement('afterend', sentinel);

  var observer = new IntersectionObserver(function (entries) {
    sentinelVisible = entries[0].isIntersecting;
    if (sentinelVisible) {
      loadNextPage();
    }
  }, { rootMargin: '0px 0px 2000px 0px' });

  observer.observe(sentinel);
})();
